/* @flow */

import type { NETGEM_API_V8_HUB } from '../../../libs/netgemLibrary/v8/types/Hub';

import { AVENUE_ID } from './constants';
import { AvenueType, type TitledAvenue } from './types';

const getAvenueFromId: (avenueList: ?NETGEM_API_V8_HUB, avenueId: string) => TitledAvenue | null = (avenueList, avenueId) => {
  if (!avenueList) {
    return null;
  }

  for (let index = 0; index < avenueList.length; ++index) {
    const { [index]: avenue } = avenueList;
    const { id, title } = avenue;

    if (avenueId === id) {
      const type = avenue.id === AVENUE_ID.Explore ? AvenueType.Explore : AvenueType.Regular;

      return {
        index,
        title,
        type,
      };
    }
  }

  return null;
};

export { getAvenueFromId };
